import Base from './base'
import { TeamEmailSettings as TeamEmailSettingsType } from '../types/teamEmailSettings'

export default class PublicTeamEmailSettings extends Base {
  async get(): Promise<TeamEmailSettingsType> {
    const response = await this.api.get('team_email_settings')
    return response?.data?.[0]
  }

  async getInternalDomains(): Promise<string[]> {
    const response = await this.api.get('team_internal_domain')
    return response?.data?.domains || []
  }
}
